/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { greetingConditionTypeEnumSchema } from "./greetingConditionTypeEnumSchema.ts";
import { z } from "zod";

export const greetingModelSchema = z.object({
    "id": z.string().uuid().describe("Идентификатор"),
"name": z.string().describe("Название"),
"title": z.string().describe("Заголовок"),
"description": z.string().describe("Описание"),
"isActive": z.boolean().describe("Участвует ли в расписании"),
"conditionType": z.lazy(() => greetingConditionTypeEnumSchema).describe("<p>Возможные значения:</p>\n<ul>\n<li><b>1 - Everyday</b>: Ежедневно</li>\n<li><b>2 - OnDate</b>: На дату</li>\n<li><b>3 - OnPeriod</b>: На период</li>\n</ul>\n"),
"priority": z.number().int().describe("Приоритет").nullable().nullish(),
"sendOnStartDate": z.string().date().describe("Начальная дата показа (для условий показа - ежегодно/один раз)").nullable().nullish(),
"sendOnEndDate": z.string().date().describe("Конечная дата показа (для условий показа - ежегодно/один раз)").nullable().nullish(),
"isPeriodic": z.boolean().describe("Указан период")
    })